import styled from 'styled-components'
import { tokens } from 'styling/tokens'

export const HeaderRow = styled.div`
  display: flex;
  align-items: flex-end;
  justify-content: space-between;
  flex-wrap: wrap;
  gap: 1rem;
`

export const UnknownBanner = styled.div`
  display: flex;
  align-items: flex-start;
  gap: 0.75rem;
  padding: 0.75rem 1rem;
  border-radius: ${tokens.radius.card};
  border: 1px solid ${tokens.accent.base};
  background: ${tokens.accent.soft};
`

export const UnknownBannerBody = styled.div`
  display: flex;
  flex-direction: column;
  gap: 0.25rem;
`

export const WindowGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(15rem, 1fr));
  gap: 0.875rem;
`

export const WindowCard = styled.div<{ $clickable: boolean }>`
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
  padding: 1rem;
  border-radius: ${tokens.radius.card};
  border: 1px solid ${tokens.border.hairline};
  background: ${tokens.surface.glass};
  cursor: ${({ $clickable }) => ($clickable ? 'pointer' : 'default')};
  transition: border-color ${tokens.motion.duration} ${tokens.motion.ease};

  &:hover {
    border-color: ${({ $clickable }) => ($clickable ? tokens.accent.base : tokens.border.hairline)};
  }
`

export const WindowCardTop = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 0.5rem;
`

export const MetricTileRow = styled.div`
  display: flex;
  gap: 0.5rem;
  margin-top: 0.25rem;
`

export const MetricTile = styled.div`
  flex: 1;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 0.125rem;
  padding: 0.625rem 0.375rem;
  border-radius: ${tokens.radius.control};
  background: ${tokens.surface.inset};
`

export const MetricTileValue = styled.span<{ $tone: 'primary' | 'ordered' | 'served' }>`
  font-size: 1.25rem;
  font-weight: 800;
  font-variant-numeric: tabular-nums;
  color: ${({ $tone }) =>
    $tone === 'served'
      ? tokens.status.success.fg
      : $tone === 'ordered'
        ? tokens.status.info.fg
        : tokens.text.primary};
`

export const MetricTileLabel = styled.span`
  font-size: ${tokens.font.micro};
  color: ${tokens.text.muted};
`

export const AdjustNote = styled.span`
  font-size: ${tokens.font.micro};
  color: ${tokens.accent.base};
`

export const OpenWindowLink = styled.span`
  font-size: ${tokens.font.micro};
  font-weight: 600;
  color: ${tokens.accent.base};
`

export const WindowSelectorRow = styled.div`
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: 0.5rem;
`

export const WindowSelectorBtn = styled.button<{ $active: boolean }>`
  padding: 0.375rem 0.875rem;
  border-radius: ${tokens.radius.chip};
  border: 1px solid ${({ $active }) => ($active ? tokens.accent.base : tokens.border.hairline)};
  background: ${({ $active }) => ($active ? tokens.accent.base : 'transparent')};
  color: ${({ $active }) => ($active ? tokens.accent.ink : tokens.text.secondary)};
  font-size: ${tokens.font.label};
  font-weight: 600;
  cursor: pointer;
`

export const DietChipRow = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 0.375rem;
`

export const DietChip = styled.span<{ $low: boolean }>`
  display: inline-block;
  padding: 0.125rem 0.5rem;
  border-radius: ${tokens.radius.chip};
  border: 1px solid ${({ $low }) => ($low ? tokens.status.danger.fg : tokens.border.strong)};
  font-size: ${tokens.font.micro};
  font-weight: 600;
  color: ${({ $low }) => ($low ? tokens.status.danger.fg : tokens.text.secondary)};
  white-space: nowrap;
`

export const BottomGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(18rem, 1fr));
  gap: 0.875rem;
`

export const SeverityRow = styled.div`
  display: flex;
  gap: 0.5rem;
`

export const SeverityTile = styled.div`
  flex: 1;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 0.25rem;
  padding: 0.75rem 0.375rem;
  border-radius: ${tokens.radius.control};
  background: ${tokens.surface.inset};
`

export const SeverityValue = styled.span<{ $tone: 'danger' | 'warning' | 'info' | 'muted' }>`
  font-size: 1.375rem;
  font-weight: 800;
  font-variant-numeric: tabular-nums;
  color: ${({ $tone }) =>
    $tone === 'danger'
      ? tokens.status.danger.fg
      : $tone === 'warning'
        ? tokens.accent.base
        : $tone === 'info'
          ? tokens.status.info.fg
          : tokens.text.muted};
`

export const SeverityLabel = styled.span`
  font-size: ${tokens.font.micro};
  color: ${tokens.text.muted};
`

export const DayCloseWarn = styled.div`
  padding: 0.625rem 0.875rem;
  border-radius: ${tokens.radius.control};
  border: 1px solid ${tokens.accent.base};
  background: ${tokens.accent.soft};
  font-size: ${tokens.font.label};
  color: ${tokens.accent.base};
`

export const DayCloseReady = styled.div`
  display: flex;
  align-items: center;
  gap: 0.5rem;
  font-size: ${tokens.font.label};
  color: ${tokens.text.secondary};
`
